export const VAIR_SIGNIN_EXCHANGE_API_ROUTE = '/v1/vair/signin/exchange';
export const VAIR_SIGNIN_COMPLETE_API_ROUTE = '/v1/vair/signin/complete';

/**
 * Error codes the OAuth callback can hand back via `?error=`, to VAIR_CONNECT_PAGE when the flow
 * started there and to the VAIR sign-in page otherwise.
 */
export type VairSignInErrorCode = 'no_email' | 'other_vair_connected' | 'failed';

export interface ExchangeResponsePayload {
  /** Firebase custom token; single client-side `signInWithCustomToken` call. */
  customToken: string;
  /** True when the callback had to create the Firebase account (profile completion follows). */
  isNewUser: boolean;
}

export interface CompleteResponsePayload {
  success: boolean;
}
